import { useEffect } from 'react';

/**
 * 라우트 변경 시 포인트 동기화를 위한 커스텀 훅 (Router 컨텍스트 없이)
 * @param {Function} syncFunction - 동기화 함수
 * @param {string} tokenUserID - 사용자 ID
 */
const useRouteChangeSync = (syncFunction, tokenUserID) => {
  useEffect(() => {
    if (!tokenUserID || !syncFunction) return;

    // 브라우저 히스토리 변경 감지
    const handlePopState = () => {
      syncFunction();
    };

    // SPA 내부 네비게이션 감지 (커스텀 이벤트)
    const handleRouteChange = () => {
      syncFunction();
    };

    // 이벤트 리스너 등록
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('routeChange', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('routeChange', handleRouteChange);
    };
  }, [tokenUserID, syncFunction]);
};

export default useRouteChangeSync;
